import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchVulnerabilityFindings, patchVulnerabilityFinding, createVulnerabilityFinding } from '../../services/api/vulnManagementService';

export const loadVulnFindings = createAsyncThunk('vulnManagement/load', async () => fetchVulnerabilityFindings());

export const updateVulnFinding = createAsyncThunk(
  'vulnManagement/update',
  async ({ id, changes }) => patchVulnerabilityFinding(id, changes)
);

export const addVulnFinding = createAsyncThunk('vulnManagement/add', async (payload) => createVulnerabilityFinding(payload));

const vulnManagementSlice = createSlice({
  name: 'vulnManagement',
  initialState: { status: 'idle', mutationStatus: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadVulnFindings.pending, (state) => { state.status = 'loading'; state.error = null; })
      .addCase(loadVulnFindings.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(loadVulnFindings.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addMatcher(
        (action) => [updateVulnFinding.pending.type, addVulnFinding.pending.type].includes(action.type),
        (state) => { state.mutationStatus = 'loading'; state.error = null; }
      )
      .addCase(updateVulnFinding.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        const item = state.items.find((f) => f.id === action.payload.id);
        if (item) Object.assign(item, action.payload);
      })
      .addCase(addVulnFinding.fulfilled, (state, action) => {
        state.mutationStatus = 'succeeded';
        state.items.unshift(action.payload);
      })
      .addMatcher(
        (action) => [updateVulnFinding.rejected.type, addVulnFinding.rejected.type].includes(action.type),
        (state, action) => { state.mutationStatus = 'failed'; state.error = action.error?.message || 'Vulnerability operation failed.'; }
      );
  }
});

export default vulnManagementSlice.reducer;
